import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetQueriesSlice = createSlice({
    name: "getQueries",
    initialState,
    reducers: {
        getQueriesRequest(state) {
            state.loading = true;
        },
        getQueriesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getQueriesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getQueriesRequest,
    getQueriesRequestSuccess,
    getQueriesRequestError,
} = GetQueriesSlice.actions;

export default GetQueriesSlice.reducer;
